module.exports = __webpack_public_path__ + "img/TG.d92760f4.svg";